import { GLOW_COLORS, type GlowColorOption } from '../../types/api';
import useStore from '../../store/useStore';

/**
 * Colour swatches for the fluorescent glow mode.
 * Only visually impactful in dark mode; in light mode the swatches
 * act as a preview for when the user transitions.
 */
export default function GlowColorPicker() {
    const selected = useStore((s) => s.glowColor);
    const isDark = useStore((s) => s.isDark);
    const { setGlowColor } = useStore.getState().methods;

    return (
        <div>
            <p className="mb-3 text-xs tracking-[0.2em] uppercase text-[var(--fg-muted)]">
                Leuchtfarbe
            </p>
            <div className="flex gap-3 flex-wrap">
                {GLOW_COLORS.map((c) => (
                    <GlowSwatch
                        key={c.id}
                        option={c}
                        isSelected={selected.id === c.id}
                        isDark={isDark}
                        onSelect={setGlowColor}
                    />
                ))}
            </div>
        </div>
    );
}

interface SwatchProps {
    option: GlowColorOption;
    isSelected: boolean;
    isDark: boolean;
    onSelect: (c: GlowColorOption) => void;
}

function GlowSwatch({ option, isSelected, isDark, onSelect }: SwatchProps) {
    return (
        <button
            type="button"
            onClick={() => onSelect(option)}
            title={option.label}
            aria-pressed={isSelected}
            className={[
                'h-8 w-8 rounded-full border-2 transition-transform duration-200',
                isSelected ? 'scale-125 border-white' : 'border-transparent hover:scale-110',
            ].join(' ')}
            style={{
                backgroundColor: option.cssValue,
                boxShadow: isDark && isSelected
                    ? `0 0 12px 4px ${option.cssValue}88`
                    : 'none',
            }}
        />
    );
}
